<template>
<div>
  <a v-if="!isPublic" href="javascript:void(0);"
    :class="['theme-btn theme-btn--primary my-4', unavailable ? 'theme-btn--primary-disabled' : '']"
    :aria-disabled="unavailable ? 'true' : 'false'"
    :aria-busy="state.busy ? 'true' : 'false'"
    @click="togglePush" :title="unavailable ? text('disabled', 'Disabled') : ''">
    <i class="material-icons">{{ subscribed ? 'notifications_off' : 'notifications_active' }}</i>
    <span class="">{{ label }}</span>
  </a>

  <button v-else type="button"
    :class="['theme-btn theme-btn--primary mt-4', unavailable ? 'theme-btn--primary-disabled' : '']"
    @click="togglePush"
    :title="unavailable ? text('disabled', 'Disabled') : ''"
    :aria-busy="state.busy ? 'true' : 'false'"
    :disabled="unavailable">
    <i class="material-icons">{{ subscribed ? 'notifications_off' : 'notifications_active' }}</i>
    <span class="">{{ label }}</span>
  </button>

  <p v-if="errorMessage" class="text-sm mt-2 text-red-600" role="alert">{{ errorMessage }}</p>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { pushState, resolvePushState, enablePush, disablePush } from '../helpers/accountPushState';

/**
 * Enable/disable button for the signed-in user's push notifications on this browser. All state
 * lives in helpers/accountPushState (shared with the page panels and the bell dropdown), so
 * every instance on the page updates together.
 */
export default {
  props: {
    isPublic: {
      default: true,
      type: Boolean
    }
  },
  data: () => ({
    state: pushState,
  }),
  mounted() {
    resolvePushState()
  },
  computed: {
    ...mapGetters(['locales']),
    subscribed() {
      return this.state.status === 'subscribed'
    },
    unavailable() {
      return this.state.busy || ['loading', 'unsupported', 'denied'].includes(this.state.status)
    },
    label() {
      const action = this.subscribed ? this.text('disable', 'Disable') : this.text('enable', 'Enable')
      return action + ' ' + this.text('push_notifications', 'push notifications')
    },
    errorMessage() {
      if (this.state.error === 'enable_failed' || this.state.error === 'sync_failed') {
        return this.text('push_notifications_enable_failed', 'Push notifications could not be enabled. Please try again.')
      }
      if (this.state.error === 'disable_failed') {
        return this.text('push_notifications_disable_failed', 'Push notifications could not be disabled. Please try again.')
      }
      return ''
    },
  },
  methods: {
    text(key, fallback) {
      return (this.locales && this.locales.common && this.locales.common[key]) || fallback
    },
    togglePush() {
      if (this.unavailable) {
        return
      }
      if (this.subscribed) {
        disablePush()
      } else {
        enablePush()
      }
    },
  }
}
</script>
